<template>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      Enrolled
    </button>

    <a-modal v-model="visible" title="Hostel Enrollment" :width="this.settings['isMobileView'] ? 480 : 720">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Close</a-button>
        <a-button key="submit" type="primary" htmlType="submit" :loading="loading" @click="handleSubmit">Submit</a-button>
      </template>

      <a-form class="mb-4" :form="form">
        <div class="row">
          <div class="col-12 col-md-9">
            <a-form-item label="Select Student">
              <a-select
                show-search
                size="default"
                optionFilterProp="children"
                :filterOption="true"
                :defaultValue="undefined"
                placeholder="Select Student"
                v-decorator="['student_id', { rules: [{ required: true, message: 'Please select a student!' } ] }]"
                @change="getStudents"
              >
                <a-select-option
                  v-for="student in selectedStudent"
                  :key="student"
                  :value="student.student_id">
                  {{ student.student + '|' + student.student_code + '|' + student.schoolClass + '|' + student.section  + '| Roll no.: ' + student.roll_no }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <div class="col-12 col-md-3">
            <a-form-item label="Date">
              <a-date-picker
                style="width: 100%"
                v-decorator="['enrollment_date', { rules: [{ required: true, message: 'Please input date' }], initialValue: moment() },]"
                :format=dateFormat />
            </a-form-item>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-4">
            <a-form-item label="Select Hostel" required>
              <a-select
                size="default"
                v-model="selectedHostel"
                placeholder="Select Hostel"
                optionFilterProp="children"
                style="width: 100%"
                @change="handleHostelBlocks"
                :filterOption="false"
                :defaultValue="undefined"
              >
                <a-select-option :value="0">
                  Select Hostel
                </a-select-option>
                <template v-for="item in hostel">
                  <a-select-option :key="item.id" :value="item.id">
                    {{ item.name }}
                  </a-select-option>
                </template>
              </a-select>
            </a-form-item>
          </div>
          <div class="col-12 col-md-4">
            <a-spin :spinning="blockSpinning">
              <a-form-item label="Select Block" required>
                <a-select
                  size="default"
                  v-model="selectedBlock"
                  placeholder="Select Block"
                  optionFilterProp="children"
                  style="width: 100%"
                  @change="handleBlockRooms"
                  :filterOption="false"
                  :defaultValue="undefined"
                  :disabled="!selectedHostel"
                >
                  <a-select-option :value="0">
                    Select Block
                  </a-select-option>
                  <template v-for="block in blocks">
                    <a-select-option :key="block.id" :value="block.id">
                      {{ block.name }}
                    </a-select-option>
                  </template>
                </a-select>
              </a-form-item>
            </a-spin>
          </div>
          <div class="col-12 col-md-4">
            <a-spin :spinning="roomSpinning">
              <a-form-item label="Select Room" required>
                <a-select
                  size="default"
                  v-model="selectedRoom"
                  placeholder="Select Room"
                  optionFilterProp="children"
                  style="width: 100%"
                  :filterOption="false"
                  :defaultValue="undefined"
                  :disabled="!selectedBlock"
                >
                  <a-select-option :value="0">
                    Select Room
                  </a-select-option>
                  <template v-for="room in rooms">
                    <a-select-option :key="room.id" :value="room.id">
                      {{ room.room_number }}
                    </a-select-option>
                  </template>
                </a-select>
              </a-form-item>
            </a-spin>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-12">
            <a-form-item label="Remark">
              <a-textarea placeholder="Remark" :autosize="{minRows: 2}" v-decorator="['remark']" />
            </a-form-item>
          </div>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { roomTypes, roomStatus } from '@/services/globaldata'
import moment from 'moment'
export default {
  name: 'enrollmentModal',
  props: {
    formVisible: { type: Boolean, require: true },
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      hostel: [],
      blocks: [],
      rooms: [],
      selectedHostel: 0,
      selectedBlock: 0,
      selectedStudent: [],
      selectedRoom: 0,
      blockSpinning: false,
      roomSpinning: false,
      roomTypes,
      roomStatus,
      dateFormat: 'DD-MM-YYYY',
    }
  },
  mounted: function () {
    this.getHostels()
    this.getStudents()
  },
  computed: {
    ...mapState(['settings', 'user']),
  },
  watch: {
    formVisible: function(n, o) {
      this.visible = n
    },
  },
  methods: {
    moment,
    getHostels: function() {
      this.$http.get(`/api/hostel`)
        .then(({ data }) => {
          this.hostel = data.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleHostelBlocks(value) {
      this.selectedBlock = 0
      if (value !== null) {
        this.selectedHostel = value
        this.blockSpinning = true
        this.getBlocks(value)
      }
    },
    getBlocks: function(value) {
      this.$http.get(`/api/hostel/blocks/${value}`)
        .then(({ data }) => {
          this.blocks = data
          this.blockSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    getRooms: function(value) {
      this.$http.get(`/api/hostel/block/rooms/${value}`)
        .then(({ data }) => {
          this.rooms = data
          this.roomSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleBlockRooms(value) {
      this.selectedRoom = 0
      if (value !== null) {
        this.selectedBlock = value
        this.roomSpinning = true
        this.getRooms(value)
      }
    },
    getStudents: function() {
      this.$http.get(`/api/hostel/enrollment/school/students`)
        .then(({ data }) => {
          this.selectedStudent = data.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    showModal() {
      this.visible = true
      this.getHostels()
      this.getBlocks()
      this.getRooms()
      this.getStudents()
    },
    handleCancel(e) {
      this.visible = false
    },
    handleSubmit(e) {
      this.form.validateFields((err, values) => {
        if (!err) {
          const selectedStudent = this.selectedStudent.find(student => student.student_id === values.student_id)
          const schoolEnrollmentId = selectedStudent ? selectedStudent.school_enrollment_id : null
          const formattedDate = moment(values.enrollment_date).format('YYYY-MM-DD HH:mm:ss')
          this.$confirm({
            title: `Are you sure you want to add enrollment?`,
            content: `Click on the OK button to add the enrollment!`,
            onOk: () => {
              this.$nprogress.start()
              this.$http
                .post('/api/hostel/enrollment/add', {
                  student_id: values.student_id,
                  school_enrollment_id: schoolEnrollmentId,
                  hostel_id: this.selectedHostel,
                  block_id: this.selectedBlock,
                  room_id: this.selectedRoom,
                  enrollment_date: formattedDate,
                  remark: values.remark,
                })
                .then((data) => {
                  this.visible = false
                  this.$emit('created')
                  this.form.resetFields()
                  this.$nprogress.done()
                  this.$notification['success']({
                    message: 'Enrollment successfully added!',
                    description: `Enrollment added successfully!`,
                  })
                })
                .catch(error => {
                  this.$nprogress.done()
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              console.log('Cancel')
            },
          })
        }
      })
    },
  },
}
</script>
